import type { Template } from "@/types";

export const SQ_07_H1_V6: Template[] = [
    {
        id: "sq-07-h1v6-01",
        name: "SQ 01 - H1V6",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h1_v6_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 112, y: 77, width: 493, height: 324, rotation: 0, imageRotation: 0 },
            { id: "2", x: 112, y: 409, width: 159, height: 232, rotation: 0, imageRotation: 0 },
            { id: "3", x: 279, y: 409, width: 159, height: 232, rotation: 0, imageRotation: 0 },
            { id: "4", x: 446, y: 409, width: 159, height: 232, rotation: 0, imageRotation: 0 },
            { id: "5", x: 788, y: 77, width: 382, height: 564, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1178, y: 77, width: 185, height: 278, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1178, y: 363, width: 185, height: 278, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h1v6-02",
        name: "SQ 02 - H1V6",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h1_v6_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 46, y: 147, width: 625, height: 423, rotation: 0, imageRotation: 0 },
            { id: "2", x: 763, y: 46, width: 203, height: 307, rotation: 0, imageRotation: 0 },
            { id: "3", x: 974, y: 46, width: 203, height: 307, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1185, y: 46, width: 202, height: 307, rotation: 0, imageRotation: 0 },
            { id: "5", x: 763, y: 361, width: 203, height: 306, rotation: 0, imageRotation: 0 },
            { id: "6", x: 974, y: 361, width: 203, height: 306, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1185, y: 361, width: 202, height: 306, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h1v6-03",
        name: "SQ 03 - H1V6",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h1_v6_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 66, y: 68, width: 585, height: 369, rotation: 0, imageRotation: 0 },
            { id: "2", x: 66, y: 445, width: 141, height: 204, rotation: 0, imageRotation: 0 },
            { id: "3", x: 215, y: 445, width: 140, height: 204, rotation: 0, imageRotation: 0 },
            { id: "4", x: 363, y: 445, width: 140, height: 204, rotation: 0, imageRotation: 0 },
            { id: "5", x: 511, y: 445, width: 140, height: 204, rotation: 0, imageRotation: 0 },
            { id: "6", x: 783, y: 138, width: 289, height: 442, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1080, y: 138, width: 288, height: 442, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h1v6-04",
        name: "SQ 04 - H1V6",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h1_v6_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 164, y: 73, width: 389, height: 268, rotation: 0, imageRotation: 0 },
            { id: "2", x: 164, y: 349, width: 191, height: 294, rotation: 0, imageRotation: 0 },
            { id: "3", x: 363, y: 349, width: 190, height: 294, rotation: 0, imageRotation: 0 },
            { id: "4", x: 786, y: 73, width: 446, height: 570, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1240, y: 73, width: 125, height: 185, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1240, y: 266, width: 125, height: 185, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1240, y: 459, width: 125, height: 184, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h1v6-05",
        name: "SQ 05 - H1V6",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h1_v6_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 142, y: 138, width: 432, height: 233, rotation: 0, imageRotation: 0 },
            { id: "2", x: 142, y: 379, width: 139, height: 201, rotation: 0, imageRotation: 0 },
            { id: "3", x: 289, y: 379, width: 139, height: 201, rotation: 0, imageRotation: 0 },
            { id: "4", x: 436, y: 379, width: 138, height: 201, rotation: 0, imageRotation: 0 },
            { id: "5", x: 861, y: 138, width: 283, height: 442, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1152, y: 138, width: 139, height: 217, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1152, y: 363, width: 139, height: 217, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h1v6-06",
        name: "SQ 06 - H1V6",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h1_v6_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 72, y: 140, width: 573, height: 437, rotation: 0, imageRotation: 0 },
            { id: "2", x: 861, y: 140, width: 138, height: 215, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1007, y: 140, width: 138, height: 215, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1153, y: 140, width: 138, height: 215, rotation: 0, imageRotation: 0 },
            { id: "5", x: 861, y: 363, width: 138, height: 214, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1007, y: 363, width: 138, height: 214, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1153, y: 363, width: 138, height: 214, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h1v6-07",
        name: "SQ 07 - H1V6",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h1_v6_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 164, y: 73, width: 389, height: 267, rotation: 0, imageRotation: 0 },
            { id: "2", x: 164, y: 348, width: 191, height: 295, rotation: 0, imageRotation: 0 },
            { id: "3", x: 363, y: 348, width: 190, height: 295, rotation: 0, imageRotation: 0 },
            { id: "4", x: 881, y: 73, width: 191, height: 281, rotation: 0, imageRotation: 0 },
            { id: "5", x: 881, y: 362, width: 191, height: 281, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1080, y: 73, width: 190, height: 281, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1080, y: 362, width: 190, height: 281, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h1v6-08",
        name: "SQ 08 - H1V6",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h1_v6_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 47, y: 147, width: 623, height: 422, rotation: 0, imageRotation: 0 },
            { id: "2", x: 852, y: 58, width: 144, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 852, y: 261, width: 144, height: 195, rotation: 0, imageRotation: 0 },
            { id: "4", x: 852, y: 464, width: 144, height: 194, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1004, y: 58, width: 144, height: 195, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1156, y: 58, width: 144, height: 195, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1004, y: 261, width: 296, height: 397, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h1v6-09",
        name: "SQ 09 - H1V6",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h1_v6_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 47, y: 147, width: 623, height: 422, rotation: 0, imageRotation: 0 },
            { id: "2", x: 865, y: 466, width: 135, height: 198, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1008, y: 466, width: 135, height: 198, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1151, y: 53, width: 135, height: 199, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1151, y: 260, width: 135, height: 198, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1151, y: 466, width: 135, height: 198, rotation: 0, imageRotation: 0 },
            { id: "7", x: 865, y: 53, width: 278, height: 405, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h1v6-10",
        name: "SQ 10 - H1V6",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h1_v6_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 68, width: 861, height: 580, rotation: 0, imageRotation: 0 },
            { id: "2", x: 869, y: 68, width: 183, height: 286, rotation: 0, imageRotation: 0 },
            { id: "3", x: 869, y: 362, width: 183, height: 286, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1060, y: 68, width: 183, height: 286, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1060, y: 362, width: 183, height: 286, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1251, y: 68, width: 183, height: 286, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1251, y: 362, width: 183, height: 286, rotation: 0, imageRotation: 0 }
        ],
    },

];
